module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0122.png.368dbd7c.jpg";